import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button, ModalContentContainer, TextField } from '@/components';
import { Routes } from '@/constants';
import { useGetInviteDetailsQuery, useGetSSORedirectUriQuery } from '@/store';

import { PageContainer } from '../components';

export const AcceptInvitePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { inviteToken, redirectUrl } = Object.fromEntries(
    new URLSearchParams(location.search).entries(),
  );
  const { data: inviteDetails, isLoading: isInviteDetailsLoading } =
    useGetInviteDetailsQuery(
      {
        inviteToken: inviteToken || '',
      },
      {
        skip: !inviteToken,
      },
    );

  const {
    data: ssoRedirectUri,
    isLoading: isRedirectUriLoading,
    isUninitialized,
  } = useGetSSORedirectUriQuery(
    {
      email: inviteDetails?.email?.trim() || '',
      redirect: redirectUrl || `${window.location.origin}${Routes.DISCOVER}`,
    },
    {
      skip: !inviteDetails?.email,
    },
  );

  useEffect(() => {
    if (!ssoRedirectUri && !isUninitialized && !isRedirectUriLoading) {
      navigate({
        pathname: Routes.REGISTER,
        search: new URLSearchParams(location.search).toString(),
      });
    }
  }, [
    ssoRedirectUri,
    navigate,
    location.search,
    isUninitialized,
    isRedirectUriLoading,
  ]);

  const isLoading = isInviteDetailsLoading || isRedirectUriLoading;

  return (
    <PageContainer>
      <ModalContentContainer>
        {isLoading ? (
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ gap: 1, display: 'flex', flexDirection: 'column' }}>
            <Typography variant="h1">Welcome to LumiQ</Typography>
            <Typography variant="h4" sx={{ mb: 6 }}>
              Join your colleagues at {inviteDetails?.organizationName}
            </Typography>
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              value={inviteDetails?.email}
              disabled
              sx={{
                '& .MuiInputBase-input.Mui-disabled': {
                  WebkitTextFillColor: 'text.main',
                },
              }}
            />
            <Button
              variant="primary"
              fullWidth
              sx={{
                height: 48,
                fontSize: 16,
                mt: 2,
              }}
              label="Continue"
              onClick={() => {
                if (ssoRedirectUri) {
                  window.location.href = ssoRedirectUri;
                } else {
                  navigate({
                    pathname: Routes.REGISTER,
                    search: new URLSearchParams(location.search).toString(),
                  });
                }
              }}
            />
          </Box>
        )}
      </ModalContentContainer>
    </PageContainer>
  );
};
